"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Spinner: ()=>Spinner
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const horizon_icons_namespaceObject = require("@pcln/horizon-icons");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const HorizonIcon_cjs_namespaceObject = require("../HorizonIcon/HorizonIcon.cjs");
const external_Spinner_variants_cjs_namespaceObject = require("./Spinner.variants.cjs");
const ALLOWED_SIZES = [
    'md',
    'lg',
    'xl'
];
function isGoogleMaterialSymbol(iconName) {
    return index_cjs_namespaceObject.validGoogleSymbols.includes(iconName);
}
function isCustomSvgIcon(iconName) {
    return iconName in horizon_icons_namespaceObject.iconRegistry;
}
const Spinner = ({ isLoading = true, size = 'md', emphasis = 'regular', iconName, gradientId = 'spinner-gradient-id' })=>{
    const { circleSlot, spinnerSlot, wrapperSlot, iconSlot } = (0, external_Spinner_variants_cjs_namespaceObject.spinnerVariants)({
        size,
        emphasis
    });
    const gradientColor = spinnerSlot();
    const iconElement = (0, external_react_namespaceObject.useMemo)(()=>{
        if (!iconName || !ALLOWED_SIZES.includes(size)) return null;
        if (isGoogleMaterialSymbol(iconName)) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
            className: iconSlot(),
            iconName: iconName,
            size: "16"
        });
        if (isCustomSvgIcon(iconName)) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(HorizonIcon_cjs_namespaceObject.HorizonIcon, {
            className: iconSlot(),
            name: iconName,
            size: "16"
        });
        return null;
    }, [
        iconName,
        iconSlot,
        size
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
        children: isLoading ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("svg", {
            "data-testid": "spinner-svg",
            className: wrapperSlot(),
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("defs", {
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("linearGradient", {
                        id: gradientId,
                        x1: "0%",
                        y1: "0%",
                        x2: "0%",
                        y2: "100%",
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0%",
                                stopColor: gradientColor,
                                stopOpacity: "0.001"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "10%",
                                stopColor: gradientColor,
                                stopOpacity: "0.05"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "20%",
                                stopColor: gradientColor,
                                stopOpacity: "0.06"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "40%",
                                stopColor: gradientColor,
                                stopOpacity: "0.08"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "50%",
                                stopColor: gradientColor,
                                stopOpacity: "0.02"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "70%",
                                stopColor: gradientColor,
                                stopOpacity: "0.3"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "95%",
                                stopColor: gradientColor,
                                stopOpacity: "0.9"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "100%",
                                stopColor: gradientColor,
                                stopOpacity: "1"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("circle", {
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: circleSlot(),
                            strokeWidth: "2.8"
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("circle", {
                            cx: "12",
                            cy: "12",
                            r: "10",
                            fill: "none",
                            stroke: `url(#${gradientId})`,
                            strokeDasharray: `${10 * Math.PI * 0.6} , ${10 * Math.PI * 2}`,
                            strokeWidth: "2.8",
                            strokeLinecap: "round",
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                from: "0 12 12",
                                to: "360 12 12",
                                dur: "1.25s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                }),
                iconElement && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("foreignObject", {
                    x: "0",
                    y: "0",
                    width: "100%",
                    height: "100%",
                    "data-testid": "foreign-object",
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: "scale-60 flex h-full w-full items-center justify-center",
                        children: iconElement
                    })
                })
            ]
        }) : null
    });
};
exports.Spinner = __webpack_exports__.Spinner;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Spinner"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
